(function ($) {
	class Block_Result extends BD_Block {
		constructor() {
			super();

			this.type = "result";
			this.templateID = "result-score";
			this._serverSide = true;

			this.elms = {
				finishButton: '#finishButton',
			};

			this._events = this.getEvents();

			/* custom attributes */
			this.audio = false;
		}

		getEvents() {
			const elms = this.elms;
			return [
				{
					event: "click",
					selector: elms.finishButton,
					handler: this.onFinish,
				},

			];
		}

		beforeinit() {
			this.render();
			this.setGameState();
		}

		render() {
			const _this = this;
			const htmlTemplate = $("#" + this.templateID).html();
			let template = Handlebars.compile(htmlTemplate);

			bdapi.post('game/get-results')
				.then((res) => {
					const resData = res.data;
					const data = resData.data;

					const resultAndData = { ...data, ...this._data };
					const html = template(resultAndData);
					$("#templateWrapper").html(html);

					bdjs.hideLoading();
				}).catch((err) => {

				});
		}



		setGameState() { }

		/* ========= ELEMENT FUNCTION HANDLER ===============*/

		onFinish() {
			BD_GAME_LOGIC.goToDefaultNextBlock();
		}

	}

	return new Block_Result();
})(jQuery);
